import type { AssistantPersona } from '../types';
import CheckoutRescue from './CheckoutRescue';
import { GREETING, HERO, INTRO } from './launchpad';
import {
  BOTTOM_BAR_PAGES,
  EXPLORE_SUGGESTIONS,
  FOCUS_SCREENS,
  GENERAL_SUGGESTIONS,
  PAGE_HINTS,
  TRY_SAYING,
} from './pages';

/** Abekus AI for applicants: job seekers and learners (backend `applicant/`). */
const APPLICANT_PERSONA: AssistantPersona = {
  audience: 'applicant',
  focusScreens: FOCUS_SCREENS,
  bottomBarPages: BOTTOM_BAR_PAGES,
  pageHints: PAGE_HINTS,
  generalSuggestions: GENERAL_SUGGESTIONS,
  exploreSuggestions: EXPLORE_SUGGESTIONS,
  tryHints: TRY_SAYING,
  launchpad: { intro: INTRO, hero: HERO },
  greeting: GREETING,
  plan: { name: 'Pro', path: '/store' },
  showsAiCredits: true,
  Extras: CheckoutRescue,
};

export default APPLICANT_PERSONA;
